/** Short guidance attached to the server-owned builder sections. */
export const studyBuilderGuidanceCopy = {
    unavailable: 'The guide could not be opened. You can continue setting up your test or try again.',
    start: 'Show tour',
    next: 'Next',
    previous: 'Back',
    close: 'Close guide',
    progress: '{{current}} of {{total}}',
    inactive: 'Choose a product to activate this section.',
    product: {
        title: 'Choose your product',
        description: 'Choose the product shoppers will see. Your choice makes the sections below available.',
    },
    version: {
        title: 'Choose the variant',
        description: 'Pick the exact variant a shopper buys. Its price and picture anchor the test.',
    },
    whatToTest: {
        title: 'Choose what to test',
        description: 'Pick one of your product fields and choose what you want to test it as.',
    },
    comparisons: {
        title: 'Choose what to compare',
        description: 'Choose what you want to test, then add the alternatives shoppers will compare.',
    },
    brief: {
        title: 'Name your test and set its goal',
        description: 'Give this test a name and describe the decision you want the results to help you make.',
    },
    questions: {
        title: 'Check the shopper questions',
        description: 'See the standard questions shoppers will answer.',
    },
    ownQuestions: {
        title: 'Ask your own question',
        description: 'Add your own question if there is something else you want to learn.',
    },
    audience: {
        title: 'Choose your audience',
        description: 'Choose the shopper market and filters.',
    },
    customerBackground: {
        title: 'Add your customer background',
        description: 'Optionally shape the audience with one of your store’s customer groups.',
    },
};
//# sourceMappingURL=study-builder-guidance.js.map